import { ViewModel } from '@platform/api'
let { getGlobalStorage } = ViewModel;

export default function getUserInfo(name) {
    let userDataJSON = getGlobalStorage('localStorage', 'STOREFORINFODATA');
    let userData = userDataJSON && JSON.parse(userDataJSON);
    return name && userData && userData[name];
}   